import { useState, useEffect } from 'react';

export function useIsPWA(): boolean {
  const [isPWA, setIsPWA] = useState(() => {
    // Check if running as PWA (standalone mode)
    if (typeof window === 'undefined') return false;
    
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as { standalone?: boolean }).standalone === true || // iOS Safari
      document.referrer.includes('android-app://') // Android TWA
    );
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    
    const handleChange = (e: MediaQueryListEvent) => {
      setIsPWA(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isPWA;
}
